import * as React from 'react';
import { FormInput } from 'source/app/presentation/Shared/Form/Input/FormInput';
import Render from 'source/app/presentation/Shared/Render';
import Data from 'source/app/services/Data';
import MotwLogicServer from 'source/app/services/External/LogicServer/MotwLogicServer';
import * as toastr from 'toastr';
import IconWithText from '../../../../../services/Shared/IconWithText/IconWithText';
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";

export const AddNewComboLink = () => {
	const [ showInputs, setShowInputs ] = React.useState(false);

	return (
		<span>
			<IconWithText
				iconSuffix={EGlyphicon.asterisk}
				whenClicked={() => setShowInputs(!showInputs)}
				displayAsBlock={false}
				notALink={true}
			>
				Add Combo
			</IconWithText>
			<Render id="showNewComboInputs" when={showInputs}>
				<NewComboInputs />
			</Render>
		</span>
	);
};

function NewComboInputs() {
	const [ newComboName, setNewComboName ] = React.useState('');

	return (
		<div>
			<FormInput
				type="text"
				onChange={(event) => setNewComboName(event.target.value)}
				value={newComboName}
				label="new combo name"
				maxWidth="190px"
			/>
			<IconWithText
				iconSuffix={EGlyphicon.ok}
				whenClicked={async () => {
					if (newComboName === '') {
						return;
					}

					const response = await MotwLogicServer.CreateNewCombo(
						newComboName
					);

					toastr.success(response.result);
					setNewComboName('');
					Data.Load.AllAsync();
				}}
				displayAsBlock={false}
			/>
		</div>
	);
}
